export const getEntityRouteId = (entity) => {
  return (
    entity?.['@name'] ||
    entity?.path?.split('/').pop() ||
    entity?.['@id']?.split('/').pop() ||
    entity?.id ||
    entity?.uuid ||
    ''
  )
}

export const matchesEntityRouteId = (entity, entityId) => {
  return getEntityRouteId(entity) === entityId
}
